import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import CheckIcon from '@material-ui/icons/Check';
import { EditPaneStyle } from './EditPane.style';
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  msg:string;
}

interface IProps extends WithStyles<typeof EditPaneStyle> {
  inEditMode:boolean;
  msg:string;
  open:boolean;
  existingSuggestion:boolean;
  close:() => void;
  updateMsg:(msg:string) => void;
}

class AddChatMessagePane extends React.Component<IProps, IState> {

  private paneRef:React.RefObject<HTMLDivElement>;
  private paneStart: number = 0;
  private paneHeight:number = 0;
  private isMouseDragging:boolean = false;

  constructor(props: IProps) {
    super(props);
    
    this.paneRef = React.createRef();


    this.state = {
      msg:props.msg,
    };

  }

  public componentDidMount(): void {
    this.setHeight(this.props.open?200:0);
  }

  public componentWillUnmount(): void {
    this.detachMouseHandlers();
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {

    if (this.props.msg !== prevProps.msg) {
      this.setState({msg:this.props.msg});
    }
    if (this.props.open !== prevProps.open) {
      this.setHeight(this.props.open?200:0);
    }
  } 



  public render() {
    const {classes} = this.props;

    return (
      <div className={classes.pane} ref={this.paneRef}
        style={{display:(this.props.inEditMode?'flex':'none')}}>
        <div className={classes.paneDragger} onClick={() => {return;}} style={{cursor:'ns-resize'}}
          onTouchStart={(e) => this.moveStart(e)} 
          onTouchMove={(e) => this.moveMove(e)} 
          onTouchEnd={(e) => this.moveEnd(e)}
          onMouseDown={this.handleMouseDown} ><div className={classes.paneMarker}/></div>
        <div className={classes.paneOptions} style={{paddingBottom: '4px'}}>
          <Button className={classes.paneOption} style={{textAlign: 'start'}} onClick={() => 
            {this.props.updateMsg(this.state.msg); this.props.close();}}
            startIcon={<BackArrowIcon />} classes={{text:classes.paneBackButton}}>{tn.lang.back}</Button>
          <div className={classes.paneOption} style={{textAlign: 'center', fontWeight: 200}}>{tn.lang.calMessage}</div>
          <div style={{flex:1}}/>
        </div>
        <textarea 
          className={classes.messageText}
          name="msg" 
          id="msg" 
          autoCorrect="on" 
          spellCheck={true}
          autoComplete="off" 
          autoFocus={false}
          onChange={(edit) => this.setState({msg:edit.target.value})}
          value={this.state.msg}
          placeholder={tn.lang.calAddMessage}
          style={{height:'100%'}}
        />
      </div>
    );
  }

  private setHeight(height:number) {
    if (this.paneRef.current) {
      this.paneRef.current.style.height = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.maxHeight = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.minHeight = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.border = ((this.props.open
        ?"1px solid #cdcdcd"
        :"0px solid #cdcdcd"
      ));

      this.paneRef.current.style.boxShadow = ((this.props.open
        ?'0px 0px 10px rgba(113, 101, 113, 0.27)'
        :'0px 0px 10px rgba(113, 101, 113, 0)'));
      this.paneHeight = (this.props.open?height:0);
    }
  }

  private moveStart(e:React.TouchEvent<HTMLDivElement>) {
    this.startPaneDrag(e.touches[0].screenY);
  }

  private moveMove(e:React.TouchEvent<HTMLDivElement>) {
    this.updatePaneDrag(e.touches[0].screenY);
  }

  private moveEnd(e:React.TouchEvent<HTMLDivElement>) {
    this.finishPaneDrag();
  }

  private handleMouseDown = (e:React.MouseEvent<HTMLDivElement>) => {
    if (e.button !== 0) {
      return;
    }
    this.isMouseDragging = true;
    this.startPaneDrag(e.screenY);
    window.addEventListener('mousemove', this.handleWindowMouseMove);
    window.addEventListener('mouseup', this.handleWindowMouseUp);
    window.addEventListener('blur', this.handleWindowMouseCancel);
  };

  private handleWindowMouseMove = (e:MouseEvent) => {
    if (!this.isMouseDragging) {
      return;
    }
    this.updatePaneDrag(e.screenY);
  };

  private handleWindowMouseUp = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.finishPaneDrag();
    this.detachMouseHandlers();
  };

  private handleWindowMouseCancel = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.finishPaneDrag();
    this.detachMouseHandlers();
  };

  private startPaneDrag(screenY:number) {
    this.paneStart = screenY;
    if (this.paneRef.current) {
      this.paneRef.current.style.transition = "unset";
    }
  }

  private updatePaneDrag(screenY:number) {
    const newY = screenY;
    const delta =  this.paneStart - newY;

    if (this.paneRef.current) {
      let newPaneHeight:number = this.paneHeight + delta;
      if (newPaneHeight < 200) {newPaneHeight =  200;}
      if (window.innerHeight - newPaneHeight < 150) {newPaneHeight = window.innerHeight-150;}
  

      if (this.paneHeight !== newPaneHeight) {
        this.paneStart = newY;
        this.setHeight(newPaneHeight);
      }
    }
  }

  private finishPaneDrag() {
    this.paneStart=0;
    if (this.paneRef.current) {
      this.paneRef.current.style.transition = "all 0.5s";
    }
  }

  private detachMouseHandlers() {
    window.removeEventListener('mousemove', this.handleWindowMouseMove);
    window.removeEventListener('mouseup', this.handleWindowMouseUp);
    window.removeEventListener('blur', this.handleWindowMouseCancel);
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
  };
}

export default connect(mapStateToProps)(withStyles(EditPaneStyle)(AddChatMessagePane));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/AddChatMessagePane.tsx